import { Model } from '@vuex-orm/core'

export default class Lesson extends Model {
  static entity = 'lessons'

  static fields() {
    return {
      id: this.string(''),
      name: this.string(''),
      description: this.string(''),
      slug: this.string(''),
      thumbnail_image: this.string(''),
      lesson_plan_url: this.attr(''),
      activity_sheet_url: this.attr(''),
      custom_class_id: this.attr(null),
      linked_classes: this.attr([]),
      total_slides: this.attr(null),
      pre_quiz_count: this.attr(null),
      post_quiz_count: this.attr(null),
      lesson_slides: this.attr(null),
      lesson_modules: this.attr(null)
    }
  }
}
